<template>
  <v-container>
    <v-card flat max-width="500px" style="margin:auto;">
      <div class="pa-6 pt-10">
        <v-text-field
          dense
          outlined
          v-model="oldPassword"
          label="Old Password *"
        >
        </v-text-field>
        <v-text-field
          dense
          outlined
          v-model="newPassword"
          label="New Password *"
        >
        </v-text-field>
        <v-text-field
          dense
          outlined
          v-model="newPasswordConfirm"
          label="Confirm Password *"
        >
        </v-text-field>
        <v-card-actions class="justify-center">
          <v-btn large class="pl-5 pr-5" color="success">Submit</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  }),
  mounted() {
    this.$store.commit("setPageTitle", "Change Password");
  },
};
</script>

<style>
</style>